// extracted by mini-css-extract-plugin
module.exports = {"PlaytechServices":"PlaytechServices_PlaytechServices__1ymPe","Wrap":"PlaytechServices_Wrap__2Z0yw"};